import React, { useState } from 'react'

export default App = () => {
  const [validation, setValidation] = useState(null)
  const [lookupResult, setLookupResult] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const handleLookup = (e) => {
    e.preventDefault()
    setIsLoading(true)
    const handleFetch = fetch(vck_app.handle_uri, {
      method: 'POST',
      mode: 'same-origin',
      credentials: 'include',
      cache: 'no-cache',
      headers: new Headers({
        Accept: 'application/json',
        'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      }),
      body: `action=vck_lookup&validation=${validation}`,
    })
      .then((data) => data.json())
      .catch((e) => `رد شد: ${e}`)
    handleFetch.then((res) => {
      setLookupResult({ ...res })
      setIsLoading(false)
    })
  }

  return (
    <div className='warranty-wrapper'>
      {lookupResult == null && (
        <form onSubmit={(e) => handleLookup(e)}>
          <label htmlFor='validation'>{vck_app.validation_field}</label>
          <input
            type='text'
            name='validation'
            onChange={(e) => setValidation(e.target.value)}
          />
          <button type='submit' className='btn btn-indigo'>
            {!isLoading && vck_app.validation_button_field}
            {isLoading && (
              <svg
                id='registering'
                xmlns='http://www.w3.org/2000/svg'
                fill='none'
                viewBox='0 0 24 24'
              >
                <circle
                  className='opacity-25'
                  cx='12'
                  cy='12'
                  r='10'
                  stroke='currentColor'
                  strokeWidth='4'
                ></circle>
                <path
                  className='opacity-75'
                  fill='currentColor'
                  d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
                ></path>
              </svg>
            )}
          </button>
        </form>
      )}
      {lookupResult != null && (
        <>
          <div>
            <svg
              onClick={() => setLookupResult(null)}
              className='btn-back'
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M14 5l7 7m0 0l-7 7m7-7H3'
              />
            </svg>
            <span className='msg-back'>{vck_app.back_button_field}</span>
          </div>
          <section className='lookup-result' id={lookupResult.status}>
            {lookupResult.status === 'ok' && (
              <>
                {vck_app.validation_field}: <b>{validation}</b> <br />
                {vck_app.validation_desc_field}:{' '}
                <span style={{whiteSpace: 'pre-wrap', fontWeight: 'bold', marginBottom: '10px'}}>{String(lookupResult.description)}</span> <br />
                {lookupResult.thumbnail_url && (
                  <div className='image-wrapper'>
                    <img src={lookupResult.thumbnail_url} />
                  </div>
                )}
              </>
            )}
            {lookupResult.status === 'fail' && (
              <>
                {vck_app.validation_field}: <b>{validation}</b> <br />
                {vck_app.validation_desc_field}:{' '}
                <b>{vck_app.invalid_validation_msg}</b> <br />
              </>
            )}
          </section>
        </>
      )}
    </div>
  )
}
